import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect/lib/index';
import { getFlexibleDates } from '../../redux/flexibleDates/actions';
import { Config, DateUtils } from '../../utils';
import { SearchSegment, TripTypeProp } from '../../models';
import { getTripType, displayFaresInCalendar, getSegments } from '../../redux/currentSearch/selectors';

export const FaresLoader = ({ children, tripType, date, getFlexibleDates, displayFaresInCalendar, segments }) => {
    const daysWithFares = Config.get('daysWithFares');
    const segment = segments[0];

    useEffect(() => {
        if (displayFaresInCalendar) {
            const origin = segment && segment.origin;
            const destination = segment && segment.destination;
            const parsedDate = DateUtils.stringToDate(date);
            const requestedDate = new Date(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate());
            getFlexibleDates({
                daysWithFares,
                origin,
                destination,
                date: requestedDate,
                tripType,
            }).then(()=>{}, ()=>{});
        }
    }, [date, segment]);

    return children;
};

FaresLoader.propTypes = {
    tripType: TripTypeProp.isRequired,
    getFlexibleDates: PropTypes.func.isRequired,
    date: PropTypes.instanceOf(Date),
    displayFaresInCalendar: PropTypes.bool.isRequired,
    segments: PropTypes.arrayOf(SearchSegment).isRequired,
};

FaresLoader.defaultProps = {
    date: DateUtils.getToday(),
};

const mapStateToPropsSelector = createStructuredSelector({
    tripType: getTripType,
    displayFaresInCalendar: displayFaresInCalendar,
    segments: getSegments,
});

const connected = connect(mapStateToPropsSelector, {
    getFlexibleDates,
    getSegments,
})(FaresLoader);

export { connected as ConnectedFaresLoader };
